exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clickable-root{align-items:center;cursor:pointer;display:inline-flex;justify-content:center;line-height:1;pointer-events:auto;text-align:center;white-space:nowrap}", ""]);

// Exports
exports.locals = {
	"root": "clickable-root"
};